// extracted by mini-css-extract-plugin
export default {"heading":"Autenticate_heading__27KNv"};